<template>
  <li class="app-product-information-sheet">
    <slot name="txtBefore"></slot>
    <a :href="sheetLink">
      {{productInformation.pibName}}
      <span class="version" v-if="showVersion">
        &nbsp;({{sheet.version}})
      </span>
    </a>
    <slot name="txtAfter"></slot>
  </li>
</template>

<script>
import { mapGetters } from 'vuex'

/**
 * Diese Komponete übernimmt die Darstellung eines einzelnen Informationsblattes als Downloadlink
 */
export default {
  props: {
    sheet: {
      type: Object,
      default: () => {}
    },
    productInformation: {
      type: Object,
      default: () => {}
    },
    showVersion: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapGetters([
      'brand'
    ]),
    sheetLink: function () {
      const baseUrl = this.$config.apiUrl || ''
      return `${baseUrl}/api/document/product-information-sheet/${this.brand}/${this.sheet.documentReference}.pdf`
    }
  },
  name: 'ProductInformationSheet'
}
</script>
